<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'AnalyticsSection',
  mounted() {
    this.SET_SECTION('Analytics');
  },
  methods: {
    ...mapMutations(['SET_SECTION']),
  },
};
</script>
